import type { File, FolderFolder } from '@openapi'
import type {
  SelectedPage,
  SelectedFile,
  SelectedFolder,
  RecentFileWithFavoriteId,
  FolderItemWithFolderId,
  FolderFileWithFolderId,
} from '@content-selector/stores/app'

export function createPageId(fileId: File['id'], pageIndex: number) {
  return `file-${fileId}-page-index-${pageIndex}`
}

export function getFileId(item: { file?: { id: File['id'] }; id: File['id'] }) {
  return item.file?.id || item.id.split('|')[0]
}

export function isShareable(
  item:
    | SelectedFile
    | SelectedFolder
    | SelectedPage
    | RecentFileWithFavoriteId
    | FolderItemWithFolderId
    | FolderFileWithFolderId
    | (FolderFolder & { folder_id?: string; type: 'folder' }),
) {
  if ('permissions' in item) {
    return item.permissions?.can_share !== false
  }

  return true
}
